<template>
  <button @click="exportSitemap" class="btn btn-info btn-sm">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0,
    }
  },
  methods: {
    exportSitemap: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/admin-sitemap', {
          params: params
        })
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            title: item.title ? item.title : '',
            path: item.path ? item.path : '',
            description: item.description ? item.description : '',
            permission: item.permission ? item.permission : '',
            note: item.note ? item.note : '',
            createTime: item.createTime ? moment(item.createTime).format('DD/MM/YYYY HH:mm:ss') : '',
            updateTime: item.updateTime ? moment(item.updateTime).format('DD/MM/YYYY HH:mm:ss') : '',
          }
          sheet.addRow(row)
          this.downloadedCount += 1;
        })
      } while (response && response.hasNextPage);
      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
        'sitemap.xlsx')
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      })
    },
    setupSheet(sheet) {
      sheet.columns = [
        {header: this.$t('title'), key: 'title', width: 20},
        {header: this.$t('path'), key: 'path', width: 50},
        {header: this.$t('description'), key: 'description', width: 50},
        {header: this.$t('permission'), key: 'permission', width: 50},
        {header: this.$t('note'), key: 'note', width: 50},
        {header: this.$t('createTime'), key: 'createTime', width: 20},
        {header: this.$t('updateTime'), key: 'updateTime', width: 20},
      ]
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Title',
        path: 'Path',
        description: 'Description',
        permission: 'Permission',
        note: 'Note',
        createTime: 'Create Time',
        updateTime: 'Update Time',
      },
      vi: {
        title: 'Tiêu đề',
        path: 'Đường dẫn',
        description: 'Mô tả',
        permission: 'Quyền hạn',
        note: 'Ghi chú',
        createTime: 'Tạo lúc',
        updateTime: 'Cập nhật lúc'
      }
    }
  }
}
</script>